import {
  AppstoreOutlined,
  CheckSquareOutlined,
  DatabaseOutlined,
  IssuesCloseOutlined,
  SettingOutlined,
  TeamOutlined,
  CalendarOutlined,
  ContainerOutlined,
} from "@ant-design/icons";
import { Button, Menu } from "antd";
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { $t } from "~/i18n.js";
import { Icon, StartIcon, clipboard } from "../../icon/icon.jsx";
import "./LargeMenu.css";
import { clubHasFlight } from "~/featureMatrix.jsx";

/**
 * @deprecated Use a smarter solution to get the current menu
 * @param {*} currentPage
 * @returns
 */
function getCurrentMenuFromUrl(currentPage = "") {
  // check open menu and page
  let currentMenu = "";

  if ("home" === currentPage) {
    currentMenu = "home";
  } else if (
    ["start", "total", "dailyreport", "tow", "rosters"].includes(currentPage)
  ) {
    currentMenu = "vluchten";
  } else if (
    ["material", "status", "report", "maintenancehours"].includes(currentPage)
  ) {
    currentMenu = "mat";
  } else if (["my_starts", "my_details"].includes(currentPage)) {
    currentMenu = "profiel";
  } else if (["members", "dto", "email", "news"].includes(currentPage)) {
    currentMenu = "lid";
  } else if (
    [
      "flights",
      "users",
      "groups",
      "competencies",
      "settings",
      "financial",
    ].includes(currentPage)
  )
    currentMenu = "admin";

  return currentMenu;
}

export const LargeMenu = ({
  showCheckDataButton = false,
  triggerShowCheckModal = () => {},
  club = {},
  profile = {},
  isDTOview = false,
  isAssociationview = false,
}) => {
  let location = useLocation();
  let currentPage = location.pathname.replace("/admin", "").split("/")[1] || "home";
  const currentMenu = getCurrentMenuFromUrl(currentPage);

  const [openKeys, setOpenKeys] = useState(currentMenu ? [currentMenu] : []);
  useEffect(() => {
    if (currentMenu) {
      setOpenKeys((prev) => (prev.includes(currentMenu) ? prev : [currentMenu]));
    }
  }, [currentMenu]);

  const NonDTONonAss = !isAssociationview && !isDTOview;

  return (
    <Menu
      key="Sidebar"
      className="sideMenuBar"
      theme="dark"
      mode="inline"
      style={{
        backgroundColor: "var(--primary)",
      }}
      selectedKeys={[currentPage]}
      openKeys={openKeys}
      onOpenChange={setOpenKeys}
    >
      {NonDTONonAss && (
        <>
          {profile.vliegt && showCheckDataButton && (
            <Menu.Item key="hide_werkbij">
              <Button
                className="whiteButton"
                onClick={triggerShowCheckModal}
                style={{ width: 140 }}
              >
                {$t("Werk gegevens bij")}
              </Button>
            </Menu.Item>
          )}

          {NonDTONonAss && <Menu.Item key="home" icon={<AppstoreOutlined />}>
            <Link to="/">{$t("Thuis")}</Link>
          </Menu.Item>}

          {NonDTONonAss &&
            (profile.zichzelf_aanmelden || profile.iedereen_aanmelden) && (
              <Menu.Item key="register" icon={<Icon icon={clipboard} />}>
                <Link to="/register">{$t("Aanmelden")}</Link>
              </Menu.Item>
            )}

          {NonDTONonAss &&
            clubHasFlight() &&
            (profile.make_reservering || profile.wijzig_reservering) && (
              <Menu.Item key="reservations" icon={<CalendarOutlined />}>
                <Link to="/reservations">{$t("Reserveren")}</Link>
              </Menu.Item>
            )}

          {NonDTONonAss &&
            clubHasFlight() &&
            (profile.vliegt ||
              profile.wijzig_start ||
              profile.wijzig_vluchten) && (
              <Menu.SubMenu
                key="vluchten"
                icon={<StartIcon />}
                title={$t("Vluchten")}
              >
                {NonDTONonAss &&
                  (profile.vliegt ||
                    profile.wijzig_start ||
                    profile.wijzig_vluchten) && (
                    <Menu.Item key="start">
                      <Link to="/start">{$t("Startadmin")}</Link>
                    </Menu.Item>
                  )}
                {NonDTONonAss && profile.wijzig_sleep && (
                  <Menu.Item key="tow">
                    <Link to="/tow">{$t("Sleepadmin")}</Link>
                  </Menu.Item>
                )}
                {NonDTONonAss &&
                  profile.ziet_dto &&
                  profile.zichzelf_aanmelden && (
                    <Menu.Item key="dailyreport">
                      <Link to="/dailyreport">{$t("Dagverslagen")}</Link>
                    </Menu.Item>
                  )}
                {NonDTONonAss && profile.zichzelf_aanmelden && (
                  <Menu.Item key="rosters">
                    <Link to="/rosters">{$t("Roosters")}</Link>
                  </Menu.Item>
                )}
              </Menu.SubMenu>
            )}

          {NonDTONonAss && !clubHasFlight() && profile.zichzelf_aanmelden && (
            <Menu.Item key="rosters" icon={<CalendarOutlined />}>
              <Link to="/rosters">{$t("Roosters")}</Link>
            </Menu.Item>
          )}

          {NonDTONonAss &&
            !clubHasFlight() &&
            profile.ziet_dto &&
            profile.zichzelf_aanmelden && (
              <Menu.Item key="dailyreport" icon={<CheckSquareOutlined />}>
                <Link to="/dailyreport">{$t("Dagverslagen")}</Link>
              </Menu.Item>
            )}

          {NonDTONonAss && clubHasFlight() && profile.vliegt && (
            <Menu.SubMenu
              key="mat"
              icon={<IssuesCloseOutlined />}
              title={$t("Materieel")}
            >
              {NonDTONonAss && (
                <Menu.Item key="material">
                  <Link to="/material">{$t("Overzicht")} </Link>
                </Menu.Item>
              )}
              {NonDTONonAss && (
                <Menu.Item key="report">
                  <Link to="/report">{$t("Meldingen")}</Link>
                </Menu.Item>
              )}
              {NonDTONonAss &&
                (profile.wijzig_winteruren || profile.goedkeuren_uren) && (
                  <Menu.Item key="maintenancehours">
                    <Link to="/maintenancehours">{$t("Onderhoudsuren")}</Link>
                  </Menu.Item>
                )}
            </Menu.SubMenu>
          )}
        </>
      )}

      {profile.ziet_dto || profile.ziet_emaillijst || profile.wijzig_news ? (
        <Menu.SubMenu key="lid" icon={<TeamOutlined />} title={$t("Leden")}>
          {!isAssociationview && (
            <Menu.Item key="members">
              <Link to="/members">{$t("Ledenlijst")}</Link>
            </Menu.Item>
          )}
          {!isAssociationview && profile.ziet_dto && (
            <Menu.Item key="dto">
              <Link to="/dto">{$t("DTO lijst")}</Link>
            </Menu.Item>
          )}
          {profile.ziet_emaillijst && (
            <Menu.Item key="email">
              <Link to="/email">{$t("Email")}</Link>
            </Menu.Item>
          )}
          {profile.wijzig_news && (
            <Menu.Item key="news">
              <Link to="/news">{$t("Nieuws")}</Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      ) : (
        <>
          <Menu.Item key="members" icon={<TeamOutlined />}>
            <Link to="/members">{$t("Ledenlijst")}</Link>
          </Menu.Item>
        </>
      )}

      {!isDTOview && (
        <>
          <Menu.Item key="documents" icon={<DatabaseOutlined />}>
            <Link to="/documents">{$t("Documenten")}</Link>
          </Menu.Item>

          {!isDTOview && profile.wijzig_findings && (
            <Menu.Item key="findings" icon={<CheckSquareOutlined />}>
              <Link to="/findings">{$t("Bevindingen")}</Link>
            </Menu.Item>
          )}

          {!isDTOview && profile.ziet_staff && (
            <Menu.SubMenu
              key="admin"
              icon={<SettingOutlined />}
              title={$t("Admin")}
            >
              {NonDTONonAss && clubHasFlight() && (
                <Menu.Item key="flights">
                  <Link to="/admin/flights">{$t("Vluchten")}</Link>
                </Menu.Item>
              )}
              {!isDTOview && profile.wijzig_leden && (
                <Menu.Item key="users">
                  <Link to="/admin/users">{$t("Gebruikers")}</Link>
                </Menu.Item>
              )}
              {!isDTOview && profile.wijzig_leden && (
                <Menu.Item key="groups">
                  <Link to="/admin/groups">{$t("Groepen")}</Link>
                </Menu.Item>
              )}
              {!isDTOview && profile.wijzig_dto && (
                <Menu.Item key="competencies">
                  <Link to="/admin/competencies">{$t("Bevoegdheden")}</Link>
                </Menu.Item>
              )}
              {!isDTOview && (profile.wijzig_financial || profile.view_financial) && (
                <Menu.Item key="financial">
                  <Link to="/admin/financial">{$t("Financieel")}</Link>
                </Menu.Item>
              )}
              {!isDTOview && (
                <Menu.Item key="settings">
                  <Link to="/admin/settings">{$t("Club Settings")}</Link>
                </Menu.Item>
              )}
            </Menu.SubMenu>
          )}

          {!isDTOview && club && club.voorval_link && (
            <Menu.Item style={{ marginTop: 42 }} key="hide_melding">
              <Button
                className="whiteButton"
                target="_blank"
                rel="noopener noreferrer"
                style={{ width: 140 }}
                href={club.voorval_link}
              >
                {$t("Meld voorval")}
              </Button>
            </Menu.Item>
          )}
        </>
      )}

      <Menu.Item key="hide_zweefLogo" className="bottomBackgroundElement" />
    </Menu>
  );
};
